module.exports = __webpack_public_path__ + "media/images/icon__externalLink@3x-1c64ce3e378e3afc6772fddcd025c1a5.png";